<template>
  <div>
    <vue-file-upload
      :ref="uploaderRef"
      class="d-none"
      action="POST"
      :target="url"
      @start="startUpload"
      @finish="finishUpload"
      @error="uploadError"
      @progress="uploadProgress"
    />

    <button class="btn btn-light btn-upload" @click="upload">
      <i class="fal fa-upload mr-2" />

      <span>{{ addFilesText }}</span>

      <div v-if="progress" class="progress-bar" :style="{ width: progress + '%' }" />
    </button>
  </div>
</template>

<script>
import { Successes } from '@/enums/successes.enum';
import { notificationsMixin } from '@/mixins/notifications';
import { config } from '@/utils/config';
import VueFileUpload from './VueFileUpload';
import { Errors } from '@/enums/errors.enum';

// @vuese
// Uploader plików
// @group formComponents
export default {
  components: { VueFileUpload },
  mixins: [notificationsMixin],
  props: {
    // schema
    schema: {
      type: Object,
      required: false
    },
    // Tekst przycisku dodawania plików
    addFilesText: {
      type: String,
      required: false,
      default: 'Dodaj pliki'
    }
  },
  data() {
    return {
      uploaderRef: 'uploaderRef_' + new Date().getTime(),
      url: config.mediaURL,
      progress: 0
    };
  },
  methods: {
    // @vuese
    // Początek uploadu
    startUpload(event) {
      this.$store.commit('media/setIsUploading', true);
      this.progress = 1;
    },
    // @vuese
    // Koniec uploadu
    finishUpload(event) {
      this.clearUpload();
      const file = JSON.parse(event.target.response);
      file.name = file.fileName;
      this.notifySuccess(`${Successes.FILE_ADDED} ${file.name}`);
      this.$emit('fileAdded', file);
    },
    // @vuese
    // Obsługa błędu uploadu
    uploadError() {
      this.notifyError(Errors.FILE_UPLOAD_FAILED);
      this.clearUpload();
    },
    // @vuese
    // Czyści upload
    clearUpload() {
      this.progress = 0;
      this.$store.commit('media/setIsUploading', false);
      this.$refs[this.uploaderRef].$el.value = '';
    },
    // @vuese
    // Postęp uploadu
    uploadProgress(progress) {
      this.progress = progress;
    },
    // @vuese
    // Kliknięcie w niewidoczny komponent
    upload() {
      this.$refs[this.uploaderRef].$el.click();
    }
  }
};
</script>

<style>
.btn-upload {
  position: relative;
}

.progress-bar {
  height: 5px;
  margin: 0 !important;
  background-color: blue;
  position: absolute;
  left: 0;
  bottom: 0;
}
</style>
